import { Pipe, PipeTransform } from '@angular/core';
import { PlantingSiteDto } from 'src/app/models/trofaco/plantingSiteDto';

@Pipe({
    name: 'siteMapIcon'
})
export class SiteMapIconPipe implements PipeTransform {

    private readonly greenPin = '/assets/img/map-icons/map-s-green.png';
    private readonly redPin = '/assets/img/map-icons/map-s-red.png';
    private readonly greenFocusPin = '/assets/img/map-icons/map-m-green.png';
    private readonly redFocusPin = '/assets/img/map-icons/map-m-red.png';

    transform(site?: PlantingSiteDto, selectedSite?: PlantingSiteDto): string {
        if (site == null) return '';

        if (site.availableTrees !== 0) {
            if (site != selectedSite) 
                return this.greenPin;
            else 
                return this.greenFocusPin;
        } else {
            if (site != selectedSite) 
                return this.redPin;
            else 
                return this.redFocusPin;
        }

    }

}
